import { useRef } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { formatValueWithK } from '../../utils/helpers';

import classes from './MetaGameWidget.module.scss';
import type { MetagameWidgetDirection, MetaGameWidgetProps } from './types';

const getContainerClassName = (direction?: MetagameWidgetDirection) => {
  if (direction === 'horizontal') {
    return classes.horizontal;
  }
  return '';
};

export function MetaGameWidget(props: MetaGameWidgetProps) {
  const {
    amount,
    width,
    direction,
    className,
    imageWidth,
    currencySymbol,
    dataTestId,
    metagameIconClassName,
    metagameTextContainerClassName,
    metagameTextClassName,
  } = props;
  const parentRef = useRef(null);
  const { t } = useTranslation();
  return (
    <div
      ref={parentRef}
      className={classNames(className, classes.metaGameWidget, getContainerClassName(direction))}
      data-testid={dataTestId}
      style={{ width }}
    >
      <img
        className={classNames(
          'icon',
          direction === 'vertical-v2' ? classes.iconVerticalV2 : classes.icon,
          metagameIconClassName,
        )}
        src={currencySymbol}
      />
      {direction === 'vertical-v2' ? (
        <div className={classNames(classes.textContainerV2, metagameTextContainerClassName)}>
          <span className={classNames(classes.textStyleV2, metagameTextClassName)}>
            {formatValueWithK(Number(amount), t)}
          </span>
        </div>
      ) : (
        <span className={'amount'} style={{ width: imageWidth }}>
          {formatValueWithK(Number(amount), t)}
        </span>
      )}
    </div>
  );
}
